import { Form, Modal, Input, Select, Button } from "antd";
import "./CreateListingModal.css";
import { useState } from "react";
import { useMobxStores } from "../../stores/stores";

const types = [
  {
    label: "software",
    value: "software",
    format: ".zip, .dmg",
  },
  {
    label: "3D",
    value: "3D",
    format: ".obj, .fbx, .stl, .glb, .zip",
  },
  {
    label: "dataset",
    value: "dataset",
    format: ".csv, .zip, .json",
  },
  {
    label: "text",
    value: "text",
    format: ".txt, .pdf, .docx",
  },
  {
    label: "Massive Open Online Course (MOOC)",
    value: "mooc",
  },
];

const CreateListingModal = ({
  showCreateListingModal,
  setShowCreateListingModal,
  defaultValues,
  isUpdating = false,
}) => {
  const { requestsStore } = useMobxStores();
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);

  const normalizedDefaults = defaultValues
    ? {
        title: defaultValues.title,
        description: defaultValues.description,
        type: defaultValues.type,
        contact: defaultValues.email,
      }
    : {};

  const isFormChanged = (currentValues, defaultValues) => {
    return Object.keys(defaultValues).some((key) => {
      return currentValues[key] !== defaultValues[key];
    });
  };

  const handleFieldsChange = () => {
    const hasErrors = form
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);

    const currentValues = form.getFieldsValue();
    const changed = isUpdating
      ? isFormChanged(currentValues, normalizedDefaults)
      : form.isFieldsTouched(false);

    setIsFormValid(changed && !hasErrors);
  };

  const handleCancel = () => {
    setShowCreateListingModal(false);
    form.resetFields();
    setIsFormValid(false);
  };

  const handleFormSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      const formData = new FormData();

      formData.append("title", formValues.title);
      formData.append("description", formValues.description);
      formData.append("type", formValues.type);
      formData.append("status", "Pending");
      formData.append("email", formValues.contact);

      await requestsStore.PostRequestListing(formData);
      handleCancel();
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const handleEditForm = async () => {
    const fomrValues = form.getFieldsValue();
    const formData = new FormData();
    formData.append("title", fomrValues.title);
    formData.append("description", fomrValues.description);
    formData.append("type", fomrValues.type);
    formData.append("status", requestsStore.requestListing.status);
    formData.append("email", fomrValues.contact);

    await requestsStore.PatchRequestListing(
      requestsStore.requestListing.id,
      formData,
    );
    handleCancel();
  };

  return (
    <Modal
      open={showCreateListingModal}
      title="Add listing"
      width={"min(560px, 90vw)"}
      className="create-listing-modal"
      footer={[
        <Button
          key="submit"
          type="primary"
          disabled={!isFormValid}
          onClick={() => {
            if (isUpdating) {
              handleEditForm();
            } else {
              handleFormSubmit();
            }
          }}
        >
          {isUpdating ? "Update" : "Create"}
        </Button>,
      ]}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        onFieldsChange={handleFieldsChange}
        initialValues={normalizedDefaults}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Title is required" }]}
        >
          <Input maxLength={100} showCount />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Description is required" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Type"
          name="type"
          rules={[{ required: true, message: "Type is required" }]}
        >
          <Select>
            {types.map((item, index) => {
              return (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label="Contact information"
          name="contact"
          rules={[
            {
              required: true,
              message: "Contact info is required",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export { CreateListingModal };
